import { createAction } from "@reduxjs/toolkit";

// add actions related to the group
export const selectOccupantOption = createAction("SET_OCCUPANT_OPTIONS");
//export const saveUser = createAction("SAVE_USER");
